/**
 * URL du modèle 3D voiture.
 * Seule une assignation manuelle (`model3dPath`) compte ; sans elle, aperçu
 * générique (berline) — plus de matching automatique par nom / image.
 */

export const DEFAULT_CAR_3D_MODEL_URL = '/assets/cars/models3d/sedan.glb';

/**
 * URL du modèle 3D à afficher : chemin choisi dans la bibliothèque, sinon
 * berline générique (pas d’inférence depuis le nom).
 */
export function resolveCar3dModelUrl(car: { name?: string; model3dPath?: string | null }): string {
  const explicit = car.model3dPath?.trim();
  return explicit || DEFAULT_CAR_3D_MODEL_URL;
}
